import { GridColumn } from 'src/components/GridWrapper';

const InvoiceApproversColumns: GridColumn<any>[] = [
  {
    field: 'contact',
    title: 'Contact',
    filter: 'text',
    format: '',
    width: '265px',
    dataType: 'string',
    sortable: true,
  },
  {
    field: 'companyName',
    title: 'Company Name',
    filter: 'text',
    format: '',
    width: '265px',
    dataType: 'string',
    sortable: true,
  },
];

export default InvoiceApproversColumns;
